/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {LogicalElementType} from './LogicalElementType';
import {
  LogicalElementTypeFromJSON,
  LogicalElementTypeFromJSONTyped,
  LogicalElementTypeToJSON
} from './LogicalElementType';

/**
 *
 * @export
 * @interface LogicalElementItem
 */
export interface LogicalElementItem {
  /**
   *
   * @type {LogicalElementType}
   * @memberof LogicalElementItem
   */
  type: LogicalElementType;
  /**
   *
   * @type {boolean}
   * @memberof LogicalElementItem
   */
  filled?: boolean;
}

/**
 * Check if a given object implements the LogicalElementItem interface.
 */
export function instanceOfLogicalElementItem(value: object): value is LogicalElementItem {
  if (!('type' in value) || value['type'] === undefined) return false;
  return true;
}

export function LogicalElementItemFromJSON(json: any): LogicalElementItem {
  return LogicalElementItemFromJSONTyped(json, false);
}

export function LogicalElementItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LogicalElementItem {
  if (json == null) {
    return json;
  }
  return {
    type: LogicalElementTypeFromJSON(json['type']),
    filled: json['filled'] == null ? undefined : json['filled']
  };
}

export function LogicalElementItemToJSON(value?: LogicalElementItem | null): any {
  if (value == null) {
    return value;
  }
  return {
    type: LogicalElementTypeToJSON(value['type']),
    filled: value['filled']
  };
}
